var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTohirgoo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 388.78,
    width: 23.18,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.1,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.72,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71h0V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.48,5.48,0,0,0,5.46-5.46V60.66A5.48,5.48,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.73,5.73,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.7,5.7,0,0,1,453.31,337.8ZM260.21,55.2a5.48,5.48,0,0,0-5.46,5.46V332.09a5.48,5.48,0,0,0,5.46,5.46h193.1a5.48,5.48,0,0,0,5.46-5.46V60.66a5.48,5.48,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.04,
    y: 413.31,
    width: 21.6,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.14,293.29c-2.09-6-18.58,2.16-25.23,12.09-4.45,6.61-7.17,13.68-8.43,23.16.15-10.84.32-22.45.49-33.42,1.35-2.73,4.43-9.05,6.66-14,7.4-16.68,25-22.88,31.08-33.42,8-13.8,7.92-34.49,1.14-41.95C468,199.22,448.43,243.1,446.23,248a130.72,130.72,0,0,0-11.17,41.5c.15-10.31.31-19.77.44-27.11.41-23.81.93-31.47,1.16-33.82.82-1.16,1.78-2.5,2.33-3.22,4.72-6.08,15.2-13.32,20.44-22.16,7.65-12.91,6.41-28.36,1.05-34.07-5.61-6-15.53,8.2-20.79,22.28s-3,27.57-4.49,39.27c-.31,2.33-.63,11-.93,23.1-1.6-13-4.78-21.72-10.67-29.84-7.26-10-13.52-22.15-19.49-20.58s-2.76,17.67,2,29c4.21,10.06,25,20.09,28,28.18-.35,16.38-.68,37.17-.91,56.47-1.63-10-.51-10.84-7.22-26.1-4-9.09-20.34-20.3-22.28-14.05s1,18,7.18,26.33c5,6.67,16,6.66,18.59,10.8.59,1,2.56,4.64,3.69,6.79-.27,23.59-.39,44.42-.25,51.53l1.07.07c-.05-1.83.08-13.84.29-29.73,2.68-8.44,20.75-13.38,26.33-22.17C466.45,311.22,470.64,300.49,468.14,293.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.15,382.94H416.49a4,4,0,0,1-3.87-3.19l-2.47-12.14h47.4l-2.46,12.14A4,4,0,0,1,451.15,382.94Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.51,372.31H409.13a2.32,2.32,0,0,1-2.32-2.06l-1-9a2.33,2.33,0,0,1,2-2.57h51.68a2.32,2.32,0,0,1,2.34,2.31,2.44,2.44,0,0,1,0,.27l-1,9A2.3,2.3,0,0,1,458.51,372.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.91,
    y: 89.01,
    width: 69.8,
    height: 76.64,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.84,
    y: 89.01,
    width: 74.84,
    height: 76.64,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.61,
    y: 93.78,
    width: 65.3,
    height: 67.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.48,151.19h0a19.92,19.92,0,0,1,0-28.16h0L101,103.47h0a19.92,19.92,0,0,1,0,28.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.94,
    y: 206.06,
    width: 47.51,
    height: 53.62,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 206.06,
    width: 53.22,
    height: 53.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 211.55,
    width: 42.24,
    height: 42.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.88,
    y: 224.05,
    width: 17.65,
    height: 17.65,
    rx: 5.4,
    transform: "translate(-140.74 125.98) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 273.04,
    width: 21.65,
    height: 109.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.8,
    y: 273.05,
    width: 93.41,
    height: 109.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.31,
    y: 315.06,
    width: 76.39,
    height: 25.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.31,
    y: 345.85,
    width: 76.39,
    height: 25.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,318.44h17.16a2.13,2.13,0,0,0,2.11-2.11h0a2.12,2.12,0,0,0-2.11-2.11H128.92a2.11,2.11,0,0,0-2.1,2.11h0A2.11,2.11,0,0,0,128.92,318.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.31,
    y: 284.28,
    width: 76.39,
    height: 25.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,287.65h17.16a2.12,2.12,0,0,0,2.11-2.11h0a2.13,2.13,0,0,0-2.11-2.11H128.92a2.11,2.11,0,0,0-2.1,2.11h0A2.11,2.11,0,0,0,128.92,287.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,349.23h17.16a2.12,2.12,0,0,0,2.11-2.12h0a2.11,2.11,0,0,0-2.11-2.1H128.92a2.1,2.1,0,0,0-2.1,2.1h0A2.11,2.11,0,0,0,128.92,349.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.91,
    y: 267.3,
    width: 96.3,
    height: 5.74,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 267.31,
    width: 24.67,
    height: 5.74,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 432.82,
    rx: 175.17,
    ry: 13.82,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mechanisms--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.64,128.83a75.74,75.74,0,0,0-5.7-13.79h0l3.55-11.62-22.94-23L360.91,84h0a72.18,72.18,0,0,0-13.78-5.72h0l-5.7-10.73H309l-5.71,10.73A72.83,72.83,0,0,0,289.46,84h0l-11.63-3.57-23,23,3.56,11.63h0a73.79,73.79,0,0,0-5.7,13.79L242,134.56V167l10.73,5.71h0a73.07,73.07,0,0,0,5.71,13.78h0l-3.56,11.61,23,23,11.63-3.55a73.08,73.08,0,0,0,13.79,5.69L309,234h32.48l5.7-10.73h0a73.73,73.73,0,0,0,13.78-5.71l11.64,3.55,23-23L392,186.51h0a74.87,74.87,0,0,0,5.68-13.78h0L408.37,167V134.53Zm-72.46,80.83a58.89,58.89,0,1,1,58.9-58.89,58.9,58.9,0,0,1-58.9,58.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.18,100.14a50.64,50.64,0,1,0,50.66,50.64A50.64,50.64,0,0,0,325.18,100.14Zm0,94.54a43.9,43.9,0,1,1,43.89-43.91h0A44,44,0,0,1,325.18,194.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.64,128.83a75.74,75.74,0,0,0-5.7-13.79h0l3.55-11.62-22.94-23L360.91,84h0a72.18,72.18,0,0,0-13.78-5.72h0l-5.7-10.73H309l-5.71,10.73A72.83,72.83,0,0,0,289.46,84h0l-11.63-3.57-23,23,3.56,11.63h0a73.79,73.79,0,0,0-5.7,13.79L242,134.56V167l10.73,5.71h0a73.07,73.07,0,0,0,5.71,13.78h0l-3.56,11.61,23,23,11.63-3.55a73.08,73.08,0,0,0,13.79,5.69L309,234h32.48l5.7-10.73h0a73.73,73.73,0,0,0,13.78-5.71l11.64,3.55,23-23L392,186.51h0a74.87,74.87,0,0,0,5.68-13.78h0L408.37,167V134.53Zm-72.46,80.83a58.89,58.89,0,1,1,58.9-58.89,58.9,58.9,0,0,1-58.9,58.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.18,100.14a50.64,50.64,0,1,0,50.66,50.64A50.64,50.64,0,0,0,325.18,100.14Zm0,94.54a43.9,43.9,0,1,1,43.89-43.91h0A44,44,0,0,1,325.18,194.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,193.12a39.58,39.58,0,0,0-3-7.31l1.89-6.17L180,167.45l-6.17,1.89a39.54,39.54,0,0,0-7.31-3l-3-5.66H146.24l-3,5.66a39.54,39.54,0,0,0-7.31,3l-6.17-1.89-12.18,12.19,1.88,6.17a40.2,40.2,0,0,0-3,7.31l-5.7,3v17.24l5.7,3a39.5,39.5,0,0,0,3,7.31l-1.88,6.17,12.18,12.19,6.17-1.89a40.24,40.24,0,0,0,7.31,3l3,5.65h17.24l3-5.65a40.24,40.24,0,0,0,7.31-3l6.17,1.89,12.19-12.19-1.89-6.17a39.58,39.58,0,0,0,3-7.31l5.69-3V196.15Zm-38.46,36.13a24.49,24.49,0,1,1,24.49-24.49,24.5,24.5,0,0,1-24.49,24.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,193.12a39.58,39.58,0,0,0-3-7.31l1.89-6.17L180,167.45l-6.17,1.89a39.54,39.54,0,0,0-7.31-3l-3-5.66H146.24l-3,5.66a39.54,39.54,0,0,0-7.31,3l-6.17-1.89-12.18,12.19,1.88,6.17a40.2,40.2,0,0,0-3,7.31l-5.7,3v17.24l5.7,3a39.5,39.5,0,0,0,3,7.31l-1.88,6.17,12.18,12.19,6.17-1.89a40.24,40.24,0,0,0,7.31,3l3,5.65h17.24l3-5.65a40.24,40.24,0,0,0,7.31-3l6.17,1.89,12.19-12.19-1.89-6.17a39.58,39.58,0,0,0,3-7.31l5.69-3V196.15Zm-38.46,36.13a24.49,24.49,0,1,1,24.49-24.49,24.5,24.5,0,0,1-24.49,24.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,196.65a8.12,8.12,0,1,0,8.12,8.12h0A8.12,8.12,0,0,0,154.86,196.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,193.12a39.58,39.58,0,0,0-3-7.31l1.89-6.17L180,167.45l-6.17,1.89a39.54,39.54,0,0,0-7.31-3l-3-5.66H146.24l-3,5.66a39.54,39.54,0,0,0-7.31,3l-6.17-1.89-12.18,12.19,1.88,6.17a40.2,40.2,0,0,0-3,7.31l-5.7,3v17.24l5.7,3a39.5,39.5,0,0,0,3,7.31l-1.88,6.17,12.18,12.19,6.17-1.89a40.24,40.24,0,0,0,7.31,3l3,5.65h17.24l3-5.65a40.24,40.24,0,0,0,7.31-3l6.17,1.89,12.19-12.19-1.89-6.17a39.58,39.58,0,0,0,3-7.31l5.69-3V196.15Zm-38.46,36.13a24.49,24.49,0,1,1,24.49-24.49,24.5,24.5,0,0,1-24.49,24.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,196.65a8.12,8.12,0,1,0,8.12,8.12h0A8.12,8.12,0,0,0,154.86,196.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,177.49l-6.6-2.72-.24-2.48a15.34,15.34,0,0,1-1.72-1.7l-2.46-.25-2.73-6.59,1.59-1.89a14.09,14.09,0,0,1,0-2.43l-1.59-1.88L198,151l2.46-.24A16.34,16.34,0,0,1,202.2,149l.24-2.47,6.6-2.72,1.88,1.58a16.42,16.42,0,0,1,2.43,0l1.88-1.58,6.6,2.72.23,2.47a17.35,17.35,0,0,1,1.72,1.71l2.46.24,2.72,6.59-1.58,1.88a14.09,14.09,0,0,1,0,2.43l1.58,1.89-2.72,6.59-2.46.25a15.43,15.43,0,0,1-1.72,1.71l-.23,2.47-6.6,2.72-1.88-1.58a16.29,16.29,0,0,1-2.42,0Zm4.78-3,1.71,1.41,5-2.07.2-2.21.24-.18a14.37,14.37,0,0,0,1.93-1.89l.18-.23,2.21-.21,2.07-5L226,162.35v-.29a13.84,13.84,0,0,0,0-2.73V159l1.41-1.72-2.07-5-2.2-.2-.19-.24A13.72,13.72,0,0,0,221,150l-.24-.19-.2-2.2-5-2.08L213.82,147h-.29a12.46,12.46,0,0,0-2.73,0h-.3l-1.71-1.42-5,2.08-.21,2.2-.22.19a13.27,13.27,0,0,0-1.94,1.88l-.19.24-2.21.2-2.09,5,1.42,1.71v.29a12.46,12.46,0,0,0,0,2.73v.3L196.93,164l2.08,5,2.2.21.19.22a13.11,13.11,0,0,0,1.93,1.94l.23.18.21,2.22,5,2.07,1.72-1.41h.29a13.84,13.84,0,0,0,2.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,167.72a7.66,7.66,0,1,1,4.14-10h0a7.65,7.65,0,0,1-4.13,10Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,161.86a.47.47,0,0,1-.47-.47V159a.47.47,0,0,1,.94,0v2.35A.47.47,0,0,1,160,161.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,154.79a.47.47,0,0,1-.47-.47V149.6a.47.47,0,0,1,.94,0v4.72A.47.47,0,0,1,160,154.79Zm0-9.44a.47.47,0,0,1-.47-.47v-4.72a.47.47,0,0,1,.94,0v4.72A.47.47,0,0,1,160,145.35Zm0-9.43a.48.48,0,0,1-.47-.48v-4.71a.47.47,0,1,1,.94,0v4.71A.48.48,0,0,1,160,135.92Zm0-9.47a.44.44,0,0,1-.47-.44v-.07a14.48,14.48,0,0,1,.79-4.72.48.48,0,0,1,.6-.29.46.46,0,0,1,.29.6,13.43,13.43,0,0,0-.74,4.41A.51.51,0,0,1,160,126.45Zm3-8.72a.45.45,0,0,1-.29-.1.47.47,0,0,1-.08-.66,14.48,14.48,0,0,1,3.62-3.23.47.47,0,0,1,.5.8,13.33,13.33,0,0,0-3.38,3A.5.5,0,0,1,163.08,117.73Zm7.85-4.9a.47.47,0,0,1-.1-.93,14.2,14.2,0,0,1,3.12-.34h1.67a.47.47,0,1,1,0,.94H174a13.61,13.61,0,0,0-2.92.32Zm80.19-.33H246.4a.47.47,0,0,1,0-.94h4.72a.47.47,0,1,1,0,.94Zm-9.44,0H237a.47.47,0,1,1,0-.94h4.71a.47.47,0,1,1,0,.94Zm-9.43,0h-4.72a.47.47,0,0,1,0-.94h4.72a.47.47,0,1,1,0,.94Zm-9.44,0h-4.72a.47.47,0,0,1,0-.94h4.72a.47.47,0,1,1,0,.94Zm-9.44,0h-4.72a.47.47,0,0,1,0-.94h4.72a.47.47,0,1,1,0,.94Zm-9.44,0h-4.71a.47.47,0,1,1,0-.94h4.71a.47.47,0,1,1,0,.94Zm-9.43,0h-4.72a.47.47,0,0,1,0-.94h4.72a.47.47,0,1,1,0,.94Zm-9.44,0h-4.72a.47.47,0,0,1,0-.94h4.72a.47.47,0,1,1,0,.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.21,112.5h-2.36a.47.47,0,0,1,0-.94h2.36a.47.47,0,1,1,0,.94Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.75,
    y: 277.69,
    width: 4.93,
    height: 154.07,
    transform: "translate(324.44 709.46) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.17,335.52h81.42a0,0,0,0,1,0,0v11.29a0,0,0,0,1,0,0H285.17a3.71,3.71,0,0,1-3.71-3.71v-3.87A3.71,3.71,0,0,1,285.17,335.52Z",
    transform: "translate(648.04 682.32) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.74,
    y1: 432.62,
    x2: 353.84,
    y2: 339.37,
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.82550010634003px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.15,
    y1: 437.24,
    x2: 331.25,
    y2: 343.99,
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.82550010634003px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.94,
    y1: 432.62,
    x2: 283.84,
    y2: 339.37,
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.82550010634003px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.53,
    y1: 437.24,
    x2: 306.43,
    y2: 343.99,
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.82550010634003px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,328.08h81.42a0,0,0,0,1,0,0v11.29a0,0,0,0,1,0,0H292.39a3.71,3.71,0,0,1-3.71-3.71v-3.87A3.71,3.71,0,0,1,292.39,328.08Z",
    transform: "translate(662.49 667.45) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,328.08h81.42a0,0,0,0,1,0,0v11.29a0,0,0,0,1,0,0H292.39a3.71,3.71,0,0,1-3.71-3.71v-3.87A3.71,3.71,0,0,1,292.39,328.08Z",
    transform: "translate(662.49 667.45) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.1,
    y: 281.37,
    width: 4.93,
    height: 154.07,
    transform: "translate(581.13 716.82) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,293.1s-56.35,2.12-65.71,24.74c0,0,1.3,67.37,8.84,89.48l16.13-1.83L261.58,340l58.29-46.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,293.1s-56.35,2.12-65.71,24.74c0,0,1.3,67.37,8.84,89.48l16.13-1.83L261.58,340l58.29-46.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.49 422.35 251.42 422.35 251.28 415.64 251.18 410.38 261.02 410.98 261.21 415.64 261.49 422.35",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.21 415.64 251.28 415.64 251.18 410.38 261.02 410.98 261.21 415.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.99 412.52 244.43 413.17 240.5 405.17 265.39 404.94 265.99 412.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,423.87s.52-5.91-1.54-5.09S247.54,422.62,248.84,423.87Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10,
      strokeWidth: "0.94183336878001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,423.87s-4.43-3.1-5.56-1.52S248.84,423.87,248.84,423.87Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10,
      strokeWidth: "0.94183336878001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.35,421l8,.08a2.28,2.28,0,0,1,2.22,2.1l.56,7.07a2.19,2.19,0,0,1-2.23,2.38c-4.33-.13-13.24-.36-16.4-.27-4.23.12-10.24.19-11.1-1.42a2.09,2.09,0,0,1,.51-2.66s11.53-1.07,16.83-6.55A2.27,2.27,0,0,1,252.35,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,293.1s1.07,13.13.67,23.28c-.46,11.7-25.65,22-62.32,16,0,0-2.86,19.77-13,38s-26,45.26-26,45.26l-15.6-10.15s20.54-57,24.45-72.82,5.46-23.41,16.64-28.35,35.63-11.22,35.63-11.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.84 412.66 246.99 415.5 242.92 421.77 235.11 417.22 239.2 410.86 240.79 408.4 248.84 412.66",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.84 412.66 246.99 415.5 239.2 410.86 240.79 408.4 248.84 412.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.87 410.38 238.42 398.14 235.11 406.31 254.52 417.52 258.87 410.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,417.52s1.49-5.12-.18-5.22S229.76,417.52,229.76,417.52Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10,
      strokeWidth: "0.94183336878001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.37,417.33s-2.31-5.56-4.17-4.32S229.37,417.33,229.37,417.33Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10,
      strokeWidth: "0.94183336878001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,416.66l6.82,4a2.19,2.19,0,0,1,.85,2.87l-3.09,6.27a2.21,2.21,0,0,1-3.13.9c-3.67-2.26-11.24-6.89-14-8.38-3.72-2-8.93-4.92-8.86-6.71a2.08,2.08,0,0,1,1.79-2s10.48,4.82,17.83,2.82A2.33,2.33,0,0,1,236.12,416.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.16,235.72s-2.1,22.94-1.26,28.84c0,0-21.92,3.21-33,1.69l-7.42-1.86-9.28,2.27,2.53,7.35h7.42s5.4,1.52,7.76,0c0,0,18.55,3.71,29.51,2.53s14.36-5.35,14.85-13.66c.46-8,5.73-25.82,1.52-29.87Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,238.3s-8.41-21.36-16.59-26.18-46.06,4.4-46.06,4.4-16.25,5.23-17.18,30.62l14.93,6.33,2.36,39.63h50.56l-.27-51.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.48,174.66s-5-.63-6.36-4.38,3.86-1.86,3.42-8.64,7.35-8.4,13-5.42,14.62-.27,18,3.8,1.9,7.86,1.9,7.86,9.72,11-2.6,18.51S305.48,174.66,305.48,174.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.88,211.21c-5.4,8.23-10.26,9.08-16.77,9.07-7.31,0-4.86-5.19-4.86-5.19,3.06-1.53,5.29-3.17,5.64-6.94a14.88,14.88,0,0,0,.05-2.2,19.54,19.54,0,0,0-.87-5c-10.35.94-14-4.11-15.29-13.64a29.33,29.33,0,0,1,3.06-17.05c6,7.06,17.29,1.53,17.29,1.53-3.17,9.17,4.59,12.46,4.59,12.46,3-1.88,5.4-.24,5.17,3.41a5.1,5.1,0,0,1-3.41,4.59C328.89,208.5,334.88,211.21,334.88,211.21Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,191.06a.32.32,0,0,1-.32-.3.32.32,0,0,1,.3-.34c3.62-.19,5-1.93,5.05-1.95a.31.31,0,0,1,.44-.05.32.32,0,0,1,.06.45c-.06.08-1.58,2-5.51,2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,187.12l-.59-6.07-2.62,5.52A3.28,3.28,0,0,0,308.69,187.12Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,181.05c0,.76.35,1.38.79,1.38s.79-.62.79-1.38-.35-1.38-.79-1.38S312.73,180.29,312.73,181.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.69,
    cy: 181.05,
    rx: 0.79,
    ry: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,178a.41.41,0,0,1-.35-.18c-.05-.08-1.36-1.84-4.4-1.28a.42.42,0,0,1-.5-.34.44.44,0,0,1,.34-.5c3.6-.66,5.19,1.53,5.26,1.63a.43.43,0,0,1-.35.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.35,177.44a.46.46,0,0,1-.2-.05.42.42,0,0,1-.18-.57,3.31,3.31,0,0,1,3.33-1.57.42.42,0,0,1,.36.48.41.41,0,0,1-.47.36,2.48,2.48,0,0,0-2.46,1.12A.45.45,0,0,1,303.35,177.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.67,185.78a4.73,4.73,0,1,1,4.74-4.73A4.73,4.73,0,0,1,302.67,185.78Zm0-8.83a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,302.67,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,185.78a4.73,4.73,0,1,1,4.73-4.73A4.74,4.74,0,0,1,314,185.78Zm0-8.83a4.1,4.1,0,1,0,4.09,4.1A4.11,4.11,0,0,0,314,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.41,
    y1: 181.05,
    x2: 309.23,
    y2: 181.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.94183336878001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.39,
    y1: 181.92,
    x2: 327.26,
    y2: 184.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.94183336878001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,200a22.6,22.6,0,0,1-2.56,5.91,19.54,19.54,0,0,0-.87-5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.54 253.47 302.54 247.14 299.98 252.39 302.54 253.47",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.27 245.02 342.32 233.63 341.77 246.03 344.27 245.02",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.22,268.92c-.12,8.33-3.87,12.48-14.84,13.66s-29.51-2.53-29.51-2.53c-2.36,1.52-7.76,0-7.76,0h-7.42l-2.52-7.35,9.27-2.26,7.42,1.85c11.13,1.52,33.05-1.68,33.05-1.68-.63-4.42-1.34-18.85-1.64-25.59l13.08-3.87C358.64,250,358.33,261.74,358.22,268.92Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.77,225.42l8.85,45.11a4.32,4.32,0,0,0,4.23,3.47h74.93a4.3,4.3,0,0,0,4.23-5.06l-8-45.11a4.29,4.29,0,0,0-4.23-3.54H169A4.29,4.29,0,0,0,164.77,225.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,220.29,255.23,274h0a2.24,2.24,0,0,0,2.21-2.64l-8.77-49.23a2.23,2.23,0,0,0-2.21-1.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5,278.31H289.74a4.3,4.3,0,0,0-4.31-4.31H178.83A4.32,4.32,0,0,0,174.5,278.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,278.31h38.07a4.3,4.3,0,0,0-4.31-4.31H256A4.32,4.32,0,0,0,251.67,278.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,248.82c.81,5.61,4.69,9.7,8.67,9.13s6.55-5.59,5.75-11.2-4.69-9.7-8.67-9.13S200.92,243.2,201.73,248.82Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5,278.31H289.74a4.3,4.3,0,0,0-4.31-4.31H178.83A4.32,4.32,0,0,0,174.5,278.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,283.89h199a7.12,7.12,0,0,0-7.12-7.12H134.43a7.13,7.13,0,0,0-7.13,7.12Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTohirgoo);
export default __webpack_public_path__ + "static/media/Tohirgoo.2c36444d4bea698c418c6540b9152d07.svg";
export { ForwardRef as ReactComponent };